// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create_resource_offline_codemirror .CodeMirror{height:calc(90vh - 260px)!important}.CodeMirror-wrap pre.CodeMirror-line-like,.create_resource_offline_codemirror .CodeMirror-wrap pre.CodeMirror-line{word-break:break-all}.create_resource_offline_codemirror .CodeMirror-scroll{height:calc(90vh - 260px)!important;overflow-y:hidden;overflow-x:auto}", ""]);
// Exports
module.exports = exports;
